import { React, useState, useRef, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { PseudoCodeList } from './PseudoCodeList/PseudoCodeList';
import { Container, Stack, Button } from 'react-bootstrap';
import { useControlCentreContext } from 'contexts/ControlCentreContext';
import { useConfig } from 'contexts/ConfigContext';
import SetOverrideModal from '../PseudoCodesManagement/PseudoCodeList/SetOverrideModal';
import { useTranslation } from 'react-i18next';
export function PseudoCodeManagement() {
    const { t } = useTranslation();
    const { configData } = useConfig();
    const { controlCentre } = useControlCentreContext();
    let _modalRef = useRef(null);
    //#region -------------------------------- STATES 
    const [pseudoOrigin, setPseudoOrigin] = useState({
        controlCentreText: controlCentre.centrename,
        pseudoCodeId: '',
        pseudoCode: '',
        pseudoCodeText: '',
        pseudoCodeDescription: ''
    });
    const [overrideDestination, setOverrideDestination] = useState({
        controlCentreText: controlCentre.centrename,
        pseudoCodeId: '',
        pseudoCode: '',
        pseudoCodeText: '',
        pseudoCodeDescription: ''
    });
    const [centreConfig, setCentreConfig] = useState({
        ControlCentreId: controlCentre.centreid,
        ControlCentreText: controlCentre.centrename,
        PseudoCodeId: '',
        PseudoCode: '',
        PseudoCodeText: '',
        PseudoCodeDescription: '',
        OverrideCodeId: '',
        BlockingTimeSet: []
    });
    const [showModal, setShowModal] = useState(false);
    //#endregion

    //#region -------------------------------- EFFECTS

    useEffect(() => {
        setCentreConfig({
            ...centreConfig,
            PseudoCodeId: pseudoOrigin.pseudoCodeId,
            PseudoCode: pseudoOrigin.pseudoCode,
            PseudoCodeText: pseudoOrigin.pseudoCodeText,
            PseudoCodeDescription: pseudoOrigin.pseudoCodeDescription,
            OverrideCodeId: overrideDestination.pseudoCodeId,
            BlockingTimeSet: [configData.equipmentDefaultBlockingTime]
        })
    }, [pseudoOrigin, overrideDestination])
    //#endregion

    //#region -------------------------------- HANDLERS
    const handleShowModal = (show) => {
        setShowModal(show);
    };
    //#endregion

    return (
        <Container fluid className="px-5" style={{ maxWidth: '960px' }}>
            <Stack direction="horizontal" gap={3} className="mt-4 justify-content-between">
                <h2>{t('ccSearch')}</h2>
                <Link to={`/controlCentreConfig/${controlCentre.centreid}`}><Button variant="outline-secondary">{t('ccReturnControlCentre')}</Button></Link>
            </Stack>
            <PseudoCodeList pseudoCode={pseudoOrigin} setPseudo={setPseudoOrigin} overrideCode={overrideDestination} setOverride={setOverrideDestination} showModal={handleShowModal} />
            <SetOverrideModal
                ref={_modalRef}
                show={showModal}
                handleShow={handleShowModal}
                setOrigin={setPseudoOrigin}
                setDestination={setOverrideDestination}
                origin={pseudoOrigin}
                destination={overrideDestination}
                centreConfig={centreConfig}
            />
        </Container>
    )

}